import { ValidationPattern } from './regx';
import momentjs from 'moment-jalaali';

const removeItemFromArray = (error, errors = []) => {
  return errors.filter((er) => er !== error);
};
const addItemToArray = (error, errors = []) => {
  const temp = errors.find((er) => er === error);
  if (temp) return errors;
  else return [...errors, error];
};
const setError = (key, error, errors) => {
  switch (key) {
    case true: {
      return removeItemFromArray(error, errors);
    }
    case false: {
      return addItemToArray(error, errors);
    }
    default:
      return errors;
  }
};
const validData = ({ field, value, pattern }) => {
  const regexPattern = pattern ?? ValidationPattern[field];
  return new RegExp(regexPattern).test(value) ? true : false;
};

const checkNationalCode = (nationalCode) => {
  if (isNaN(nationalCode)) {
    return false;
  } else if (nationalCode == '') {
    return false;
  } else if (nationalCode.length < 10 || nationalCode.length > 10) {
    return false;
  } else {
    if (!/^\d{10}$/.test(nationalCode)) return false;
    const check = +nationalCode[9];
    const sum =
      nationalCode
        .split('')
        .slice(0, 9)
        .map((x, i) => +x * (10 - i))
        .reduce((x, y) => x + y) % 11;
    return sum < 2 ? check == sum : check + sum == 11;
  }
};
const ErrorMessages = {
  persian: 'form.invalid',
  english: 'form.invalid',
  number: 'form.invalid',
  username: 'form.invalid',
  password: 'form.invalid',
  email: 'form.invalid',
  phone: 'form.invalid',
  phone: 'form.invalid',
  code: 'form.invalid',
  url: 'form.invalid',
  age: 'form.invalid',
  boolean: 'form.boolean',
  string: 'form.invalid',
  text: 'form.invalid',
  required: 'form.required',
  iranianNationalCode: 'form.invalid',
  default: 'form.invalid',
  passengerAge: 'form.invalid',
  passportExpireDate: 'booking.validpassportdate',
  otpInput: 'form.invalid',
  cardNo: 'form.invalid',
  monthDays: 'form.invalid',
  year: 'form.invalid',
};
export class validation {
  constructor() {}
  static required = (value, customMessage, error) => {
    const errors = setError(
      value ? true : false,
      customMessage ?? ErrorMessages.required,
      error,
    );

    return { errors, value };
  };
  static optional = (value, customMessage, error = []) => {
    let errors = error;
    if (!value) errors = [];

    return { value, errors };
  };
  static array = (value, customMessage) => {
    const result = !!Array.isArray(value) && value.length > 0;
    const errors = setError(result, customMessage ?? ErrorMessages.default, []);

    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };

  static string = (value, customMessage) => {
    const result = validData({ field: 'string', value });
    const errors = setError(result, customMessage ?? ErrorMessages.string, []);

    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
  static boolean = (value, customMessage) => {
    let result = false;
    if (typeof value === 'boolean') result = true;
    const errors = setError(result, customMessage ?? ErrorMessages.boolean, []);
    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
  static text = (value, customMessage) => {
    const result = validData({ field: 'text', value });
    const errors = setError(result, customMessage ?? ErrorMessages.text, []);
    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
  static passportNo = (value, customMessage) => {
    const result = validData({ field: 'passportNumber', value });
    const errors = setError(result, customMessage ?? ErrorMessages.text, []);
    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
  static number = (value, customMessage) => {
    const result = validData({ field: 'number', value });
    const errors = setError(result, customMessage ?? ErrorMessages.number, []);
    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
  static positiveNumber = (value, customMessage) => {
    const result = validData({ field: 'positiveNumber', value });
    const errors = setError(result, customMessage ?? ErrorMessages.number, []);
    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
  static positiveFloat = (value, customMessage) => {
    const result = validData({ field: 'positiveFloat', value });
    const errors = setError(result, customMessage ?? ErrorMessages.number, []);
    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
  static english = (value, customMessage) => {
    const result = validData({ field: 'englishName', value });
    const errors = setError(result, customMessage ?? ErrorMessages.english, []);

    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
  static persian = (value, customMessage) => {
    const result = validData({ field: 'persianName', value });
    const errors = setError(result, customMessage ?? ErrorMessages.persian, []);
    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
  static username = (value, customMessage) => {
    const result = validData({ field: 'userName', value });
    const errors = setError(
      result,
      customMessage ?? ErrorMessages.username,
      [],
    );
    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
  static password = (value, customMessage) => {
    const result = validData({ field: 'password', value });
    const errors = setError(
      result,
      customMessage ?? ErrorMessages.password,
      [],
    );
    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
  static email = (value, customMessage) => {
    const result = validData({ field: 'email', value });
    const errors = setError(result, customMessage ?? ErrorMessages.email, []);
    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
  static phone = (value, customMessage) => {
    const result = validData({ field: 'phone', value });
    const errors = setError(result, customMessage ?? ErrorMessages.phone, []);
    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };

  static code = (value, customMessage) => {
    const result = validData({ field: 'code', value });
    const errors = setError(result, customMessage ?? ErrorMessages.code, []);
    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
  static url = (value, customMessage) => {
    const result = validData({ field: 'url', value });
    const errors = setError(result, customMessage ?? ErrorMessages.url, []);
    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
  static age = (value, customMessage) => {
    const result = validData({ field: 'age', value });
    const errors = setError(result, customMessage ?? ErrorMessages.age, []);
    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
  static iranianNationalCode = (value, customMessage) => {
    const result = checkNationalCode(value);

    const errors = setError(
      result,
      customMessage ?? ErrorMessages.iranianNationalCode,
    );

    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };

  static date = (value, customMessage) => {
    const result =
      momentjs(value, 'YYYY-MM-DD').isValid() ||
      momentjs(value, 'YYYY/MM/DD').isValid();
    const errors = setError(result, customMessage ?? ErrorMessages.string, []);

    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
  static passengerAge = (
    value,
    flightDateTime,
    passengerType,
    customMessage,
  ) => {
    let result = false;
    if (
      momentjs(value, 'YYYY-MM-DD').isValid() ||
      momentjs(value, 'YYYY/MM/DD').isValid()
    ) {
      const flightDate = new Date(flightDateTime);
      const date = new Date(value);
      if (date && date != 'Invalid Date') {
        result = checkAge({ passengerType, flightDate, date });
      } else result = false;
    } else result = false;
    const errors = setError(
      result,
      `booking.${passengerType.toLowerCase()}ageerror`,
      [],
    );
    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
  static passportExpireDate = (value, flightDate, customMessage) => {
    let result = false;
    if (
      momentjs(value, 'YYYY-MM-DD').isValid() ||
      momentjs(value, 'YYYY/MM/DD').isValid()
    ) {
      const diff = new Date(value).getTime() - new Date(flightDate).getTime();
      const dayDiff = diff / (24 * 60 * 60 * 1000);
      result = dayDiff / 30 >= 6;
    } else result = false;

    const errors = setError(
      result,
      customMessage ?? ErrorMessages.passportExpireDate,
      [],
    );
    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
  static any = (value, customMessage) => {
    const result = validData({ field: 'any', value });
    const errors = setError(result, customMessage ?? ErrorMessages.code, []);
    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
  static pattern = (value, { customMessage, pattern }) => {
    const result = validData({ value, pattern });

    const errors = setError(result, customMessage ?? ErrorMessages.default, []);
    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
  static otpInput = (value, customMessage) => {
    const result = validData({ field: 'otpInput', value });
    const errors = setError(
      result,
      customMessage ?? ErrorMessages.otpInput,
      [],
    );
    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
  static flightNumber = (value, customMessage) => {
    const result = validData({ field: 'flightNumber', value });
    const errors = setError(result, customMessage ?? ErrorMessages.code, []);
    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
  static cardNo = (value, customMessage) => {
    const result = validData({ field: 'cardNo', value });
    const errors = setError(result, customMessage ?? ErrorMessages.cardNo, []);
    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
  static monthDays = (value, dayCount, customMessage) => {
    let fieldName = '';
    switch (dayCount) {
      case 28:
        fieldName = 'monthDays_28';
        break;
      case 29:
        fieldName = 'monthDays_29';
        break;
      case 30:
        fieldName = 'monthDays_30';
        break;
      case 31:
        fieldName = 'monthDays_31';
        break;
    }
    const result = validData({ field: fieldName, value });
    const errors = setError(
      result,
      customMessage ?? ErrorMessages.monthDays,
      [],
    );
    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
  static year = (value, customMessage) => {
    const result = validData({ field: 'year', value });
    const errors = setError(result, customMessage ?? ErrorMessages.year, []);
    return {
      errors,
      value,
      required: (custommessage) => this.required(value, custommessage, errors),
      optional: (custommessage) => this.optional(value, custommessage, errors),
    };
  };
}

const checkAge = ({ passengerType, flightDate, date }) => {
  switch (passengerType) {
    //more than 12 yeras old
    case 'adult': {
      flightDate.setFullYear(flightDate.getFullYear() - 12);
      return new Date(flightDate).toISODateString() >
        new Date(date).toISODateString()
        ? true
        : false;
    }
    //more than 2 and less tahn 12 years old
    case 'child': {
      let flightDate2 = new Date(flightDate);
      flightDate.setFullYear(flightDate.getFullYear() - 12);
      flightDate2.setFullYear(flightDate2.getFullYear() - 2);

      return new Date(flightDate).toISODateString() <=
        new Date(date).toISODateString() &&
        new Date(flightDate2).toISODateString() >
          new Date(date).toISODateString()
        ? true
        : false;
    }
    //less than 2 years old
    case 'infant' || 'toddler': {
      flightDate.setFullYear(flightDate.getFullYear() - 2);
      return new Date(flightDate).toISODateString() <=
        new Date(date).toISODateString()
        ? true
        : false;
    }
    //more than 60 years old
    case 'senior': {
      return new Date(flightDate).toISODateString() >
        new Date(date).toISODateString()
        ? true
        : false;
    }
    default:
      return true;
  }
};

// export const validation = new Validation();
